<app-header4></app-header4>
<div class="page-title-area page-title-area5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="banner-content mLText">
                    <span data-animation="fadeInLeft" data-delay="0.5s" class="bienVenu">BIENVENUE À L'ISN ACADEMY</span>
                    <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title">Institut des Sciences Novatrices</h1>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="contact-us-area bg_cover" style="background-image: url(assets/images/contact-bg.jpg)">
    <div class="contact-overlay">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <div class="section-title text-center">
                        <h2 class="title">Contactez-nous</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="contact-details d-flex">
                        <div class="contact-thumb wow slideInLeft" data-wow-duration=".5s" data-wow-delay="0s">
                            <img src="assets/images/imagesAssets/contactLogo.png" alt="">
                        </div>
                        <div class="contact-form-area">
                            <form [formGroup]="inscriptionForm" (ngSubmit)="submitData()">
                                <div class="input-title">
                                    <h3 class="title c-titr">Pour tout renseignement complémentaire, n’hésitez surtout pas à nous envoyer un message à travers le formulaire ci-dessous.</h3>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="input-box mt-30">
                                            <input type="text" placeholder="Prénom et nom" class="form-control" formControlName="username" [ngClass]="{ 'is-invalid': (submitted || inscriptionForm.get('username').dirty || inscriptionForm.get('username').touched) && inscriptionForm.get('username').errors?.required}">
                                            <i class="fal fa-user c-colorIcon"></i>
                                            <div *ngIf="inscriptionForm.get('username').errors" class="invalid-feedback error">
                                                <div *ngIf="(submitted || inscriptionForm.get('username').dirty || inscriptionForm.get('username').touched) && inscriptionForm.get('username').errors?.required">le prénom et le nom sont obligatoires</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-30">
                                            <input type="email" placeholder="Email" class="form-control" formControlName="email" [ngClass]="{ 'is-invalid': (submitted || inscriptionForm.get('email').dirty || inscriptionForm.get('email').touched ) && (inscriptionForm.get('email').errors?.required || inscriptionForm.get('email').errors?.pattern)}">
                                            <i class="fal fa-envelope-open c-colorIcon"></i>
                                            <div *ngIf="inscriptionForm.get('email').errors" class="invalid-feedback error">
                                                <div *ngIf="(submitted || inscriptionForm.get('email').dirty || inscriptionForm.get('email').touched ) && inscriptionForm.get('email').errors?.required">l'email est obligatoire</div>
                                                <div *ngIf="inscriptionForm.get('email').errors?.pattern" class="errorIn">Email invalide</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-30">
                                            <input type="tel" class="form-control" formControlName="phone" autocomplete="off" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'sn'}" clearInput (focus)="isFocus=true" (blur)="isFocus=false" (hasError)="hasError($event)" (ng2TelOutput)="getNumber($event)">
                                            <i class="fal fa-phone c-colorIcon"></i>
                                            <div class="field-error" *ngIf="inscriptionForm.get('phone').errors">
                                                <div class="c-phoneEr" *ngIf="inscriptionForm.get('phone').errors.required && (inscriptionForm.get('phone').dirty || inscriptionForm.get('phone').touched || stepInfo)">
                                                    le numéro de téléphone est obligatoire</div>
                                            </div>
                                            <div class="c-phoneEr" *ngIf="inscriptionForm.get('phone').value && isFocus===false && hasPhoneError">
                                                le numéro de téléphone est invalide
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-30">
                                            <input type="text" placeholder="Objet" class="form-control" formControlName="objet">
                                            <i class="fal fa-edit c-colorIcon"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="input-box mt-30">
                                            <textarea cols="30" rows="10" placeholder="Message" class="form-control" formControlName="message"></textarea>
                                            <i class="fal fa-pencil c-colorIcon"></i>
                                            <button class="main-btn wow slideInUp c-btn" data-wow-duration="1.5s" data-wow-delay="0s" type="submit">Envoyer<i class="fal fa-long-arrow-right"></i></button>
                                        </div>
                                        <!-- <span *ngIf="loader" class="fal fa-spinner fa-pulse c-spinner"></span> -->
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="contact-details-area pb-120">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="contact-info mr-30 mt-30">
                    <div class="contact-item-1">
                        <div class="contact-info-item text-center">
                            <i class="fal fa-phone"></i>
                            <h5 class="title">Téléphone</h5>
                            <p>77 645 13 45 | 77 649 19 12 | 77 574 56 67 | 77 563 01 86</p>
                        </div>
                        <div class="contact-info-item text-center">
                            <i class="fal fa-envelope"></i>
                            <h5 class="title">Email</h5>
                            <p>infos@isn-polyscience.com</p>
                        </div>
                    </div>
                    <div class="contact-item-1">
                        <div class="contact-info-item text-center">
                            <i class="fal fa-map"></i>
                            <h5 class="title">Adresse</h5>
                            <p>Sacré-Cœur III, Angle Boulangerie Jaune</p>
                            <p>Immeuble N° 9825</p>
                        </div>
                        <div class="contact-info-item text-center">
                            <i class="fal fa-globe"></i>
                            <h5 class="title">Site Web</h5>
                            <p>www.isn-polyscience.com</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6">
                <div class="map-area mt-30">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7496149.95373021!2d85.84621250756469!3d23.452185887261447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30adaaed80e18ba7%3A0xf2d28e0c4e1fc6b!2sBangladesh!5e0!3m2!1sen!2sbd!4v1569913375800!5m2!1sen!2sbd"
                        width="600" height="450" style="border:0;" allowfullscreen=""></iframe>
                </div>
            </div> -->
        </div>
    </div>
</div>
<app-footer2></app-footer2>